import { CommonModule } from '@angular/common';
import { Component, NgModule, ChangeDetectionStrategy } from '@angular/core';
import { DxButtonModule } from 'devextreme-angular/ui/button';

@Component({
    selector: 'patricia-shortcut',
    templateUrl: './patricia-shortcut.component.html',
    styleUrls: ['./patricia-shortcut.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PatriciaShortCutComponent {

  constructor() { }

  onButtonClick() {
    //open new tab with url of Patricia
    window.open(
      'http://patricia.calysta.eu/pat',
      '_blank'
    );
  }

}

@NgModule({
  imports: [CommonModule, DxButtonModule],
  declarations: [PatriciaShortCutComponent],
  exports: [PatriciaShortCutComponent],
})
export class PatriciaShortcutModule {}
